import { LatLng } from 'leaflet';
import { db } from '../DBUtils';
import { ITrail } from '../interfaces/ITrail';
import { PlaceList, PlaceQuery } from './PlaceFactory';

export type TrailQuery = {
	filter?: {
		id?: number[];
		title?: string;
		featured?: boolean;
		has_topics?: string[]; // topic slugs
		distance_from?: { location: LatLng; radius: number };
	};
	sort?: {
		distance_from?: LatLng;
		featured?: boolean;
	};
	limit?: number;
};

export type TrailList = {
	query?: TrailQuery;
	trails: ITrail[];
	success: boolean;
	reason?: string;
};

export class TrailFactory {
	public static getEmpty() {
		const empty_set: TrailList = {
			trails: [],
			success: true,
		};
		return empty_set;
	}

	public static async getAll() {
		return db.trails
			.toArray()
			.then(async (my_trails) => {
				let retval: TrailList = {
					trails: my_trails,
					success: true,
				};
				return retval;
			})
			.catch((reason) => {
				let retval: TrailList = {
					trails: [],
					success: false,
					reason: reason,
				};
				return retval;
			});
	}

	//public static async filter(query: TrailQuery) {
	// 	// TODO : Query Not Implemented Yet
	// 	const my_trails = await db.trails.toArray();
	// 	let retval: TrailList = {
	// 		trails: my_trails,
	// 		success: true,
	// 	};
	// 	return retval;
	// }

	public static filter(poi_list: TrailList, query: TrailQuery) {
		// TODO : Query Not Implemented Yet
		const new_list = TrailFactory.getEmpty();

		new_list.query = query;
		new_list.success = true;

		if (query.filter !== undefined) {
			new_list.trails = poi_list.trails.filter((trail) => {
				if (trail.id) {
					let include_record = true;
					if (query.filter) {
						// Check for id match
						if (query.filter.id !== undefined) {
							if (!query.filter.id.includes(trail.id)) {
								include_record = false;
							}
						}

						if (query.filter.title !== undefined) {
							const searchTarget = [];

							searchTarget.push(trail.title);
							searchTarget.push(trail.short_description);
							trail.topics.map((topic) => {
								searchTarget.push(topic.title);
							});
							trail.activities.map((activity) => {
								searchTarget.push(activity.title);
							});

							if (
								searchTarget
									.join(' ')
									.toLowerCase()
									.indexOf(
										query.filter.title.toLowerCase(),
									) === -1
							)
								include_record = false;
						}
					}
					return include_record;
				} else {
					return false;
				}
			});
		}
		return new_list;
	}
}
